<template>
  <tr>
    <td>
      <b-form-input :disabled="range.id != 0" v-model="range.startPeriod" @change="$emit('rangeChange', range)" class="calculation-settings-input"></b-form-input>
    </td>
    <td>
      <b-form-input v-model="range.endPeriod" @change="$emit('rangeChange', range)" class="calculation-settings-input"></b-form-input>
    </td>
    <td>
      <b-form-input :disabled="range.id != 0" v-model="range.startValue" @change="$emit('rangeChange', range)" class="calculation-settings-input"></b-form-input>
    </td>
    <td>
      <b-form-input v-model="range.endValue" @change="$emit('rangeChange', range)" class="calculation-settings-input"></b-form-input>
    </td>
  </tr>
</template>

<script>
export default {
  props: ['range']
};
</script>

<style lang="scss" scoped>
.fixed {
  padding: 0.6rem 0.3rem 0.3rem 1rem;
}
</style>


